import { ACTIONS } from './Actions'

const reducers = (state, action) => {
  switch (action.type) {
    case ACTIONS.SCENARIO:
      return {
        ...state,
        scenario: action.payload,
      }
    case ACTIONS.HISTORYDATA:
      return {
        ...state,
        historyDataStore: action.payload,
      }

    case ACTIONS.CURRENTINDEXEDITINGHISTORY:
      return {
        ...state,
        currentIndexEditingHistory: action.payload,
      }
    case ACTIONS.SCENARIOSET:
      return {
        ...state,
        scenarioSet: action.payload,
      }
    case ACTIONS.GETRADARDATAACTION:
      return {
        ...state,
        getRadarData: action.payload,
      }
    case ACTIONS.GROUPRADARID:
      return {
        ...state,
        groupRadarIdGlobalState: action.payload,
      }
    case ACTIONS.CONTENTCARDDATA:
      return {
        ...state,
        contentData: action.payload,
      }

    case ACTIONS.TAGS:
      return {
        ...state,
        tags: action.payload,
      }
    case ACTIONS.ORIGNALTAGS:
      return {
        ...state,
        orignaltags: action.payload,
      }
    case ACTIONS.RELATEDSCENARIOSDATA:
      return {
        ...state,
        relatedScenarios: action.payload,
      }
    case ACTIONS.CONTENTSETTINGS:
      return {
        ...state,
        contentSettings: action.payload,
      }
    case ACTIONS.CONTENTTYPES:
      return {
        ...state,
        contentTypes: action.payload,
      }
    case ACTIONS.DEVPATHS:
      return {
        ...state,
        devPaths: action.payload,
      }
    case ACTIONS.RELATEDSCENARIOS:
      return {
        ...state,
        isRelatedScenariosDeactivated: action.payload,
      }
    case ACTIONS.MAINACTORS:
      return {
        ...state,
        isMainActorsDeactivated: action.payload,
      }
    case ACTIONS.TAGACTIVATED:
      return {
        ...state,
        isTagsDeactivated: action.payload,
      }
    case ACTIONS.VERBALDRIVERS:
      return {
        ...state,
        verbalDrivers: action.payload,
      }
    case ACTIONS.ACTORS:
      return {
        ...state,
        actors: action.payload,
      }

    case ACTIONS.ISTRANSLATED:
      return {
        ...state,
        isTranslated: action.payload,
      }
    case ACTIONS.LANGLISTOPTIONS:
      return {
        ...state,
        langListOpts: action.payload,
      }
    case ACTIONS.LANGFORTRANSSTATE:
      return {
        ...state,
        langForTransState: action.payload,
      }
    case ACTIONS.ISAUTOTRANS:
      return {
        ...state,
        isAutoTrans: action.payload,
      }
    case ACTIONS.DRIVERSFUTURESTABLES:
      return {
        ...state,
        driversFuturesTables: action.payload,
      }
    case ACTIONS.DATAFORTRANSLATIONCARDBODY:
      return {
        ...state,
        dataForTranslationCardBody: action.payload,
      }
    case ACTIONS.DATAFORTRANSLATIONTYPEIMAGE:
      return {
        ...state,
        contentTypeImageSrc: action.payload,
      }
    case ACTIONS.DATAFORTRANSLATIONFROMCARDHEADER:
      return {
        ...state,
        dataForTranslationFromCardHeader: action.payload,
      }
    case ACTIONS.DEVELOPMENTPATHDOM:
      return {
        ...state,
        developmentPathDOM: action.payload,
      }
    case ACTIONS.NARRATIVEDOM:
      return {
        ...state,
        narrativeDOM: action.payload,
      }
    case ACTIONS.ACTORSDOM:
      return {
        ...state,
        actorsDOM: action.payload,
      }
    case ACTIONS.DRIVERSDOM:
      return {
        ...state,
        driversDOM: action.payload,
      }
    case ACTIONS.SET_PDF_EXPORT_LOADING:
      return {
        ...state,
        pdfExportLoading: action.payload,
      }
    case ACTIONS.ISRTL:
      return {
        ...state,
        isRTL: action.payload,
      }
    default:
      return state
  }
}

export default reducers
